"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MAPPINGS = void 0;
/* eslint-disable import/prefer-default-export */

var MAPPINGS = {
  DEFAULT: {
    customeradmins: ['CustomerAdmins'],
    technician: ['CorrosionTechnician'],
    projectManager: ['ProjectManager'],
    supervisor: [],
    // none
    surveyLoader: [],
    // none
    aegionProjectManager: ['Role:PM'],
    aegionDataProcessor: ['Role:DP']
  },
  Targa: {
    customeradmins: ['CustomerAdmins'],
    technician: ['CorrosionTechnician', 'Permission:Scan.Targa.Read_Only', 'Permission:Scan.Targa.Technician'],
    projectManager: ['ProjectManager', 'Permission:Scan.Targa.Project_Manager'],
    supervisor: ['Permission:Scan.Targa.Supervisor'],
    surveyLoader: ['Permission:Scan.Targa.Survey_Loader'],
    aegionProjectManager: ['Role:PM'],
    aegionDataProcessor: ['Role:DP']
  }
};
exports.MAPPINGS = MAPPINGS;